import { render } from "./notificationOverlay.vue?vue&type=template&id=d9a21dfa"
import script from "./notificationOverlay.vue?vue&type=script&lang=js"
export * from "./notificationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__